import React, { useState, useEffect, useRef } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Drilldown from 'highcharts/modules/drilldown';
import redirectURL from "../redirectURL";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import moment from "moment";
import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';


var decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
}
var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");

var localStorageRole = (localStorage.getItem("role"))




import { Modal } from 'react-bootstrap';
Drilldown(Highcharts);  // Enable drill-down functionality
const DEPSReportedDashboard = () => {
    var [overly, setoverly] = useState('show-n')
    var [loadshow, setloadshow] = useState('show-n');
    var [ftlDamage, setFtlDamage]= useState(0);
    var [ftlExcess, setFtlExcess]= useState(0);
    var [ftlShort, setFtlShort]= useState(0);
    var [ftlPilferage, setFtlPilferage]= useState(0);
    var [ptlDamage, setptlDamage]= useState(0);
    var [ptlExcess, setptlExcess]= useState(0);
    var [ptlShort, setptlShort]= useState(0);
    var [ptlPilferage, setptlPilferage]= useState(0);
    const [chartOptions, setChartOptions] = useState({});  // State to store chart options
    var [ ftlDamageData, setFtlDamageData] = useState([]);
    var [ ftlExcessData, setFtlExcessData] = useState([]);
    var [ ftlShortData, setFtlShortData] = useState([]);
    var [ ftlPilferageData, setFtlPilferageData] = useState([]);
    var [ ptlDamageData, setPtlDamageData] = useState([]);
    var [ ptlExcessData, setPtlExcessData] = useState([]);
    var [ ptlShortData, setPtlShortData] = useState([]);
    var [ ptlPilferageData, setPtlPilferageData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false); 
    var [title, setTitle] = useState('FTL Damage Consignments');
    var [show, setshow] = useState(false)
    var [basicTitle, setbasicTitle] = useState('')
    var [basicType, setbasicType] = useState('')

    const [defaultColDef] = useState({
        sortable: true,
        filter: true,
        resizable: true
    });
    var [from_date,setfrom_date] = useState( moment().format('DD-MM-YYYY'))
    var [end_date,setend_date] = useState( moment().add(2, 'days').format('DD-MM-YYYY'))

    const gridApiRef = useRef(null);
    const gridColumnApiRef = useRef(null);
    const [rowData, setRowData] = useState();
    const statusBar = {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left"
            },
            {
                statusPanel: "agTotalRowCountComponent",
                align: "center"
            },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" }
        ]
    };
    const sideBar = {
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel"
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel"
            }
        ],
    };



    useEffect(() => {
        getData(from_date, end_date);
    }, [])

    useEffect(() => {
        // Update chart options when data changes
        setChartOptions({
            chart: {
                type: 'column',
                height: 250
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: ['FTL', 'PTL'],  // FTL first, then PTL
                title: {
                    text: null
                },
                plotLines: [{  // Plot a line to visually differentiate FTL and PTL sections
                    // color: '#FF0000', // Color of the separator line
                    // dashStyle: 'dash', // Style of the separator line (dashed)
                    // value: 1.5,  // Position where the line is drawn (between FTL and PTL)
                    // width: 2,
                    // label: {
                    //     text: 'FTL - PTL',
                    //     align: 'center',
                    //     style: {
                    //         color: 'gray'
                    //     }
                    // }
                }]
            },
            yAxis: {
                title: {
                    text: 'No. of DEPS Consignments (%)'
                },
                labels: {
                    enabled: false  // Disable the numeric labels (100, 200, 300, etc.)
                },
                lineWidth: 0,  // Remove the axis line
                tickWidth: 0,  // Remove ticks
                gridLineWidth: 0  // Remove grid lines (optional)
            },
            
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal'
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}%</b><br/>'
            },
            plotOptions: {
                column: {
                    stacking: 'normal',  // Allows stacking of bars if needed
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}%',  // Show percentage on each bar
                    }
                },
                series: {
                    cursor: 'pointer',  // Retain drilldown and click functionality
                    point: {
                        events: {
                            click: function () {
                                // FTL category handling
                                if (this.category === 'FTL') {
                                    if (this.series.name === 'Damage') {
                                        setTitle("FTL Damage Consignments");
                                        setIsModalOpen(true)
                                        setRowData(ftlDamageData);
                                    } else if (this.series.name === 'Excess') {
                                        setTitle("FTL Excess Consignments");
                                        setIsModalOpen(true)
                                        setRowData(ftlExcessData);
                                    } else if (this.series.name === 'Pilferage') {
                                        setTitle("FTL Pilferage Consignments");
                                        setIsModalOpen(true)
                                        setRowData(ftlPilferageData);
                                    } else if (this.series.name === 'Shortage') {
                                        setTitle("FTL Shortage Consignments");
                                        setIsModalOpen(true)
                                        setRowData(ftlShortData);
                                    }
                                }
                                // PTL category handling
                                else if (this.category === 'PTL') {
                                    if (this.series.name === 'Damage') {
                                        setTitle("PTL Damage Consignments");
                                        setIsModalOpen(true)

                                        setRowData(ptlDamageData);
                                    } else if (this.series.name === 'Excess') {
                                        setTitle("PTL Excess Consignments");
                                        setIsModalOpen(true)

                                        setRowData(ptlExcessData);
                                    } else if (this.series.name === 'Pilferage') {
                                        setTitle("PTL Pilferage Consignments");
                                        setIsModalOpen(true)

                                        setRowData(ptlPilferageData);
                                    } else if (this.series.name === 'Shortage') {
                                        setTitle("PTL Shortage Consignments");
                                        setIsModalOpen(true)

                                        setRowData(ptlShortData);
                                    }
                                    // setIsModalOpen(true);
                                }
                            }
                        }
                    }
                }
            },
            series: [
                {
                    name: 'Damage',
                    data: [ftlDamage, ptlDamage],  // FTL and PTL Damage data
                    color: '#1f77b4',
                    marker: {
                        symbol: 'circle'  // Use a circle marker for FTL
                    }
                },
                {
                    name: 'Excess',
                    data: [ftlExcess, ptlExcess],  // FTL and PTL Excess data
                    color: '#ff7f0e',
                    marker: {
                        symbol: 'triangle'  // Use a triangle marker for Excess
                    }
                },
                {
                    name: 'Pilferage',
                    data: [ftlPilferage, ptlPilferage],  // FTL and PTL Pilferage data
                    color: '#2ca02c',
                    marker: {
                        symbol: 'square'  // Use a square marker for Pilferage
                    }
                },
                {
                    name: 'Shortage',
                    data: [ftlShort, ptlShort],  // FTL and PTL Shortage data
                    color: '#d62728',
                    marker: {
                        symbol: 'diamond'  // Use a diamond marker for Shortage
                    }
                }
            ],
            credits: {
                enabled: false
            }
        });
    }, [ftlDamage, ftlExcess, ftlShort, ftlPilferage, ptlDamage, ptlExcess, ptlShort, ptlPilferage]);
        
    const getData = (from_date, to_date) => {
        setloadshow('show-m')
        var from_date;
        var to_date;
        if (from_date!= '' && from_date != undefined && to_date!='' && to_date!=undefined) {
            from_date = from_date;
            to_date = to_date;
        } else {
            from_date = from_date;
            to_date = to_date;
        }
        var params = {
            from_date: formatDate(from_date),
            to_date: formatDate(to_date),
        }
        var location_name = localStorage.getItem("location");
        location_name = (location_name && location_name !=="undefined" && location_name !==null) ? location_name.split(",").filter(Boolean) : [];
        var locationNameConversion = location_name.map(e => e.trim().toLowerCase());
        var entity1 = localStorage.getItem("entity")
      entity1 = (entity1 && entity1 !== "undefined" && entity1.trim() !== "" && entity1 !== null) 
      ? entity1.split(",").map(x => x.trim()).filter(Boolean) 
      : [];    
      var entityConversion = entity1.map(e=> e.trim().toLowerCase())
    
        // if(decode(localStorageRole).toLowerCase() === "user"){
            if (
                locationNameConversion &&
                locationNameConversion.length > 0 &&
                !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
                    ) {                

          params.consigner_code = locationNameConversion;
        //   params.consignee_code = location_name;
            }
            
            if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
                params.truck_seal_entity = entityConversion
            } 
      
        
        redirectURL.post('/consignments/getdepsreport', params).then((resp) => {
            try {
                var data = resp.data;

                setFtlDamageData(data.ftlDamageRecords)
                setFtlExcessData(data.ftlExcessRecords)
                setFtlShortData(data.ftlShortRecords)
                setFtlPilferageData(data.ftlPilferageRecords)

                setPtlDamageData(data.ptlDamageRecords)
                setPtlExcessData(data.ptlExcessRecords)
                setPtlShortData(data.ptlShortRecords)
                setPtlPilferageData(data.ptlPilferageRecords)


        
                var ftlDamageRecordsCount = data.ftlDamageRecords.length;
                var ftlExcessRecordsCount = data.ftlExcessRecords.length;
                var ftlShortRecordsCount = data.ftlShortRecords.length;
                var ftlPilferageRecordsCount = data.ftlPilferageRecords.length;

                var ptlDamageRecordsCount = data.ptlDamageRecords.length;
                var ptlExcessRecordsCount = data.ptlExcessRecords.length;
                var ptlShortRecordsCount = data.ptlShortRecords.length;
                var ptlPilferageRecordsCount = data.ptlPilferageRecords.length;

                

                // Now calculate the percentage
                var ftlDamageRecords = parseFloat(((ftlDamageRecordsCount / data.ftlDeliveredRecords) * 100).toFixed(2));
                var ftlExcessRecords = parseFloat(((ftlExcessRecordsCount / data.ftlDeliveredRecords) * 100).toFixed(2));
                var ftlShortRecords = parseFloat(((ftlShortRecordsCount / data.ftlDeliveredRecords) * 100).toFixed(2));
                var ftlPilferageRecords = parseFloat(((ftlPilferageRecordsCount / data.ftlDeliveredRecords) * 100).toFixed(2));

                var ptlDamageRecords = parseFloat(((ptlDamageRecordsCount / data.ptlDeliveredRecords) * 100).toFixed(2));
                var ptlExcessRecords = parseFloat(((ptlExcessRecordsCount / data.ptlDeliveredRecords) * 100).toFixed(2));
                var ptlShortRecords = parseFloat(((ptlShortRecordsCount / data.ptlDeliveredRecords) * 100).toFixed(2));
                var ptlPilferageRecords = parseFloat(((ptlPilferageRecordsCount / data.ptlDeliveredRecords) * 100).toFixed(2));

                // Set the data for each series
                setFtlDamage(ftlDamageRecords);
                setFtlExcess(ftlExcessRecords);
                setFtlShort(ftlShortRecords);
                setFtlPilferage(ftlPilferageRecords);
                setptlDamage(ptlDamageRecords);
                setptlExcess(ptlExcessRecords);
                setptlShort(ptlShortRecords);
                setptlPilferage(ptlPilferageRecords);
                

                // setFtlDamage(7);
                // setFtlExcess(2);
                // setFtlShort(5);
                // setFtlPilferage(1);
                // setptlDamage(0);
                // setptlExcess(4);
                // setptlShort(4);
                // setptlPilferage(1);
        
            } catch (e) {
                console.error('Error:', e);
            } finally {
                setTimeout(() => {
                    setloadshow('show-n');
                }, 3000);
            }
        }).catch(error => {
            console.error('Fetch error:', error);
            setTimeout(() => {
                setloadshow('show-n');
            }, 3000);
        });
    }

    const onClickHideAll = () => {
        setloadshow('show-n')
    }
    const onCloseModal = () => {
		setIsModalOpen(false);
	};
    const onGridReady = params => {
        // Assign the APIs to refs
        gridApiRef.current = params.api;
        gridColumnApiRef.current = params.columnApi;
        
        // Now you can use gridApiRef.current and gridColumnApiRef.current safely
    };
    const onGridState = () => {
        if (gridApiRef.current && gridColumnApiRef.current) {
          // Get Current Columns State and Store in a variable
          const colState = gridColumnApiRef.current.getColumnState();
    
          // Get Current RowGroup Columns State
          const rowGroupState = gridColumnApiRef.current.getRowGroupColumns();
    
          // Get Current Pivot Columns State (when Pivot Mode is enabled)
          const pivotColumns = gridColumnApiRef.current.getPivotColumns();
    
          // Get Current Filter State and store it in window.filterState
          const filterState = gridApiRef.current.getFilterModel();
          window.filterState = filterState;
    
          // Set Filter Model (if you want to re-apply the same filter state)
          gridApiRef.current.setFilterModel(window.filterState);
        }
      };
      const filterDatafordates = () => {
        // setloadshow('show-m')
        var from_date1 = from_date
        var to_date1 = end_date
        var from_date2 = from_date
        var to_date2 = end_date
        
        
        if (from_date1=="Invalid date"){
          from_date1 = '';
      }
      if (to_date1 =='Invalid date'){
          to_date1 = '';
      }
      
      if (from_date1 !=''){
          const dateObj = moment(from_date1, 'DD-MM-YYYY');
          const formattedFromDate = dateObj.toDate();
          from_date1= formattedFromDate;
      }
      if (to_date1 !=''){
          const dateObj = moment(to_date1, 'DD-MM-YYYY');
          const formattedFromDate = dateObj.toDate();
          to_date1= formattedFromDate;
      }
        if (from_date1 != '' && from_date1 != undefined && from_date1 != null && to_date1 != '' && to_date1 != undefined && to_date1 != null) {
            if (from_date1 <= to_date1) {
               getData(from_date2, to_date2)
                // setselectedData(filteredData)
                // setloadshow('show-n')
  
            }
              else{
                  setbasicTitle('From Date sholud be less than To Date')
                  setbasicType('danger')
                  setoverly('show-n')
                  setshow(true)
              }
          }
          else {
              setbasicTitle('Please Select Start Date and End date')
              setbasicType('danger')
              setoverly('show-n')
              setshow(true)
          }
      }
    const handleDatesSelected = (e) => {
        const date = moment(e).format('DD-MM-YYYY');
        setfrom_date(date)
    };
    const handleDatesSelected1 = (e) => {
        const date = moment(e).format('DD-MM-YYYY');
        setend_date(date)
    };
      var columnwithDefs = [
        {
            headerName: "Source",
            field: "consigner_state",
            width: 100,
            // filter: false,
            resizable: true,
            // cellClass : params =>{
            // 	if(params.data.stopages == 1) return 'red'
            // 		return 'green'
            // }
        },
        {
            headerName: "Destination",
            field: "consignee_state",
            width: 120,
            // filter: false,
            resizable: true,
           
            // cellClass : params =>{
            // 	if(params.data.stopages == 1) return 'red'
            // 		return 'green'
            // }
        },
        {
            headerName: "Courier Partner",
            field: "transporter_name",
            width: 150,
            // filter: false,
            resizable: true,
           
            // cellClass : params =>{
            // 	if(params.data.stopages == 1) return 'red'
            // 		return 'green'
            // }
        },
       

    ]
    var closeAlert = () => {
        setshow(false)
        setloadshow('show-n')
    }

    return (
        <>
        <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={closeAlert}
            >
            </SweetAlert>
            <div className='card-header2'>
                <div className='d-flex justify-content-between'>
                    <h1 className='heading3 mt-20p ml-5p' style={{ width: "240px" }}>DEPS Reported %</h1>
                <div className='d-flex'>
                      
                      <div className="row">

                          <div className="form-group col-xl-4 col-lg-4">
                              <div>
                                  <label className='dateStyling'> From Date </label>
                                  <Datetime
                                      className='smaller-datetime'
                                      key={from_date}
                                      // onKeyDown ={(e)=> restrictToOther(e)}
                                      placeholder="Date"
                                      disableCloseOnClickOutside={false}
                                      closeOnSelect={true}
                                      name="from_date"
                                      inputProps={{ readOnly: 'true' }}
                                      value={from_date}
                                      dateFormat="DD-MM-YYYY"
                                      id='from_date'
                                      timeFormat={false}

                                      onChange={(e) => handleDatesSelected(e)}
                                      required />
                              </div>
                          </div>
                          <div className="form-group col-xl-4 col-lg-4">
                              <div>
                                  <label className='dateStyling'> To Date </label>
                                  <Datetime
                                      className='smaller-datetime'
                                      key={end_date}
                                      placeholder="Date"
                                      disableCloseOnClickOutside={false}
                                      closeOnSelect={true}
                                      name="to_date"
                                      inputProps={{ readOnly: 'true' }}
                                      value={end_date}
                                      dateFormat="DD-MM-YYYY"
                                      id='to_date'
                                      timeFormat={false}
                                      onChange={(e) => handleDatesSelected1(e)}
                                      required />
                              </div>
                          </div>
                          <div className="form-group col-xl-4 col-lg-4">
                              <button className="custom-btn1 f10 label label-success mt-30p" onClick={filterDatafordates}>Submit</button>
                          </div>
                      </div>
                  </div>
                  </div>

                <HighchartsReact highcharts={Highcharts} options={chartOptions} />
            </div>
            <Modal
				show={isModalOpen}
				onHide={onCloseModal}
				dialogClassName="my-modal"
				centered
				>
				<Modal.Header>
					<Modal.Title style={{fontSize:"15px"}}>{title}</Modal.Title>
					<div className="close-btn-container">
					<button
						type="button"
						className="btn btn-sm btn-icon btn-outline-primary close-button"
						data-bs-dismiss="modal"
						aria-label="Close"
						onClick={onCloseModal}
					>
						<i className="fa fa-times"></i>
					</button>
					</div>
				</Modal.Header>
				<Modal.Body className="view-task">
					<div
					className="row modelGrid"
					style={{ padding: "5px 0px", width: "100%", overflow: "hidden", zIndex: "9999" }}
					>
					<div className={"col-sm-12 col-lg-12 col-md-12"} style={{ padding: "0px 20px 0px 20px", background: "#fff" }}>
						<div
						id="myGrid"
						style={{ height: "580px", width: "100%", marginTop: "10px" }}
						className="ag-theme-balham"
						>
						<AgGridReact
							columnDefs={columnwithDefs}
							defaultColDef={defaultColDef}
							rowData={rowData}
							enableCharts={true}
							enableRangeSelection={true}
							// autoGroupColumnDef={autoGroupColumnDef}
							onGridReady={onGridReady}
							onGridState={onGridState}
							statusBar={statusBar}
							sideBar= {sideBar}
							paginationPageSize={50}
							pagination={true}
							// frameworkComponents={customLoadingCellRenderer: CustomLoadingCellRenderer}
							// detailCellRendererParams={this.state.detailCellRendererParams}
							stopEditingWhenGridLosesFocus={true}
							floatingFilter={false}
							enableCellChangeFlash={true}
							suppressCellFlash={true}
							// rowClassRules={this.state.rowClassRules}
							// gridOptions={{
							// context: { componentParent: this }
							// }}
							masterDetail={true}
							// overlayNoRowsTemplate={this.state.overlayNoRowsTemplate}
						/>
						</div>
					</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					{/* <button type="button" className="btn btn-secondary" onClick={onCloseModal}>
					Close
					</button> */}
				</Modal.Footer>
				</Modal>

            <div className={"dataLoadpage1 " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)}>
                <div className="loader-box"><div className="loader"></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={onClickHideAll}></div>
        </>
    )
}
function formatDate(dateString) {
    // Split the date string into components
    const parts = dateString.split('-');
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];

    // Reformat the date string
    const newDateString = `${year}-${month}-${day}`;
    return newDateString;
}


export default DEPSReportedDashboard;
